// src/views/Restaurant/Configuracion/Usuarios/components/InvitacionesView/components/UserInvitationPage/UserInvitationPage.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { validateUserInvitation, createUserFromInvitation } from "../../../../../../../../crud/users_api/user_invitations";
import { Button, Form, Alert, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "./UserInvitationPage.scss";
import { X } from "react-bootstrap-icons";
import { faFaceSadTear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaCalendar, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import LoadingSpinner from "../../../../../../../../components/common/LoadingSpinner";

interface InvitationInfo {
  nombre: string;
  local_name: string;
  puesto_name: string;
}

interface FormData {
  username: string;
  password: string;
  confirm_password?: string;
  email: string;
  middle_name: string;
  last_name: string;
  phone_number: string;
  address: string;
  local_id: number | null;
  dob: string;
  puesto_id: number | null;
  rol_id: number | null;
  invitation_id: number | null;
}

const ErrorPage = ({ message }: { message: string }) => (
  <div className="error-invitation-page">
    <div className="logo-invitation-container">
      <img
        className="logo-invitacion"
        src={`${process.env.PUBLIC_URL}/mp_logo_02.png`}
        alt="Logo Medio Punto"
      />
    </div>
    <h1 className="error-Invitation-title">¡Ups, algo ocurrió! :c</h1>
    <p className="error-Invitation">
      No se pudo validar la invitación. ¡Contacta al administrador del local para reactivar tu invitación!
    </p>
  </div>
);

const UserInvitationPage = () => {
  const { invitation_code } = useParams();
  const navigate = useNavigate();

  let invitationParam = invitation_code;
  if (!invitationParam) {
    try {
      invitationParam = localStorage.getItem("invitationCode") || "";
    } catch (error) {
      console.error("Error al leer de localStorage", error);
    }
  }

  const invitationId = invitationParam ? Number(invitationParam.split("-").pop()) || null : null;

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState<FormData>({
    username: "",
    password: "",
    confirm_password: "",
    email: "",
    middle_name: "",
    last_name: "",
    phone_number: "",
    address: "",
    local_id: null,
    dob: "",
    puesto_id: null,
    rol_id: null,
    invitation_id: invitationId,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [invitationInfo, setInvitationInfo] = useState<InvitationInfo | null>(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [passwordError, setPasswordError] = useState<string | null>(null);

  // Estados para pasos y validaciones
  const [currentStep, setCurrentStep] = useState(1);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [passwordMismatch, setPasswordMismatch] = useState(false);

  useEffect(() => {
    if (invitation_code) {
      try {
        localStorage.setItem("invitationCode", invitation_code);
      } catch (error) {
        console.error("No se pudo guardar el invitationCode en localStorage", error);
      }
    }
  }, [invitation_code]);

  useEffect(() => {
    const fetchInvitationData = async () => {
      if (!invitationId) {
        setError("Código de invitación inválido");
        setLoading(false);
        return;
      }

      try {
        const response = await validateUserInvitation(invitationId);
        setFormData((prev) => ({
          ...prev,
          local_id: response.data.local_id,
          puesto_id: response.data.puesto_id,
          rol_id: response.data.rol_id,
          username: response.data.nombre || prev.username,
        }));

        setInvitationInfo({
          nombre: response.data.nombre,
          local_name: response.data.local_name,
          puesto_name: response.data.puesto_name,
        });

        setLoading(false);
      } catch (err) {
        setError("No se pudo validar la invitación.");
        setLoading(false);
      }
    };

    fetchInvitationData();
  }, [invitationId]);

  const toggleCalendar = () => setShowCalendar((s) => !s);
  const togglePassword = () => setShowPassword((s) => !s);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "confirm_password") {
      setPasswordMismatch(false);
      setPasswordError(null);
    }
    if (errorMessage) setErrorMessage(null);
  };

  const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Validar paso 1 (sin contraseña ahora)
  const handleValidatedNextStep = () => {
    const { username, last_name, phone_number, email, address } = formData;

    if (!username.trim() || !last_name.trim() || !phone_number.trim() || !email.trim() || !address.trim()) {
      setErrorMessage("Por favor, completa todos los campos obligatorios.");
      return;
    }

    if (!selectedDate) {
      setErrorMessage("Selecciona tu fecha de nacimiento.");
      return;
    }

    if (!isValidEmail(email.trim())) {
      setErrorMessage("El correo electrónico no tiene un formato válido.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      dob: selectedDate ? selectedDate.toLocaleDateString("en-CA") : prev.dob,
    }));

    setErrorMessage(null);
    setCurrentStep(2);
  };

  const handlePreviousStep = () => setCurrentStep(1);

 const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setError(null);
  setSuccess(null);
  setPasswordError(null);
  setErrorMessage(null);

  // Validación de coincidencia de contraseñas
  if (formData.password.trim() !== (formData.confirm_password || "").trim()) {
    setPasswordError("Las contraseñas no coinciden.");
    setPasswordMismatch(true);
    return;
  }



  try {
    // 3) (Opcional) volver a validar la invitación antes de crear
    // await validateUserInvitation(formData.invitation_id);

    createUserFromInvitation(formData).then(() => {
    }).catch((err) => {
      toast.error("Error al crear el usuario desde la invitación.");
    });

    toast.success("Usuario creado con éxito.");
    setSuccess("Usuario registrado exitosamente.");

    localStorage.setItem(
      "newCreatedUser",
      JSON.stringify({ email: formData.email, password: formData.password })
    );

    setTimeout(() => navigate("/login"), 1500);
  } catch (err: any) {
    // 2) Muestra en consola el error concreto
    console.error("❌ Error en createUserFromInvitation:", err.response || err);

    // Extrae mensaje del backend si viene
    const backendMsg = err.response?.data?.message;

    // Si es un error servidor (>=500) mostramos el modal
    if (err.response?.status >= 500) {
      setShowErrorModal(true);
    } else {
      // Para errores 4xx mostramos mensaje inline
      setErrorMessage(backendMsg || "Error al crear usuario. Revisa tus datos.");
      setShowErrorModal(false);
    }
  }
};


  if (loading) {
    return (
      <div className="loading-container">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) return <ErrorPage message={error} />;

  return (
    <div className="user-intitation-page">
      <div>
        <img
          className="logo-invitacion"
          src={`${process.env.PUBLIC_URL}/mp_logo_02.png`}
          alt="Logo Medio Punto"
        />
      </div>

      <div className="form-user-created-by-invitation-container">
        <h2>
          <FaUser /> Registro de usuario
        </h2>
        {/* Step indicator */}
        <div className="step-indicator">
          <div className={`step ${currentStep === 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}>
            <span className="step-number">1</span>
            <span className="step-label">Datos personales</span>
          </div>

          <div className="step-divider">
            <div className={`step-progress ${currentStep > 1 ? 'filled' : ''}`} />
          </div>

          <div className={`step ${currentStep === 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}>
            <span className="step-number">2</span>
            <span className="step-label">Credenciales</span>
          </div>
        </div>
        {invitationInfo && (
          <p className="description-invitation">
            Hola <span className="nombre-invitado">{invitationInfo.nombre}</span>, el local{" "}
            <span className="local-invitado">{invitationInfo.local_name}</span> te ha invitado a crear tu cuenta de{" "}
            <span className="puesto-invitado">{invitationInfo.puesto_name}</span>.
          </p>
        )}

        {success && <Alert variant="success">{success}</Alert>}
        {passwordError && <Alert variant="danger">{passwordError}</Alert>}
  {errorMessage && <div className="error-message">{errorMessage}</div>}
        <Form onSubmit={handleSubmit} className="form-register-user">
          {currentStep === 1 && (
            <div className="form-row">
              <div className="form-column">
                <Form.Control
                  type="text"
                  name="username"
                  placeholder="Nombre"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />

                <Form.Control
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  placeholder="Apellido"
                  onChange={handleChange}
                  required
                />

                <Form.Control
                  type="tel"
                  name="phone_number"
                  placeholder="Teléfono"
                  value={formData.phone_number}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-column">
                <Button variant="none" onClick={toggleCalendar} className="boton-show-calendar">
                  {selectedDate ? selectedDate.toLocaleDateString("es-ES") : "Fecha de nacimiento"} <FaCalendar />
                </Button>

                <Form.Control
                  type="text"
                  name="address"
                  placeholder="Dirección"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />

                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  placeholder="Correo electrónico"
                  onChange={handleChange}
                  required
                />
              </div>

              <Modal.Footer>
                <div className="form-modal-footer-custom">
                  <Button variant="none" className="form-button-create" onClick={handleValidatedNextStep}>
                    Siguiente
                  </Button>
                </div>
              </Modal.Footer>
            </div>
          )}

          {currentStep === 2 && (
            <div className="form-row">
              <div className="form-column">
                <div className="password-input-container">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    placeholder="Contraseña"
                    onChange={handleChange}
                    className="password-input"
                    required
                  />
                  <Button variant="none" className="toggle-password-button" onClick={togglePassword}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </Button>
                </div>
              </div>

              <div className="form-column">
                <div className="password-input-container">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="confirm_password"
                    value={formData.confirm_password || ""}
                    placeholder="Confirmar contraseña"
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({ ...formData, confirm_password: value });
                      setPasswordMismatch(false);
                      setPasswordError(null);
                    }}
                    className={`password-input ${passwordMismatch ? "input-error" : ""}`}
                    required
                  />
                  <Button variant="none" className="toggle-password-button" onClick={togglePassword}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </Button>
                </div>
              </div>

              <Modal.Footer>
                <div className="form-modal-footer-custom">
                  <Button variant="none" className="form-button-back" onClick={handlePreviousStep}>
                    Atrás
                  </Button>
                  <Button variant="none" type="submit" className="form-button-create">
                    Crear usuario
                  </Button>
                </div>
              </Modal.Footer>
            </div>
          )}
        </Form>
      </div>

      {/* Modal para el calendario */}
      <Modal show={showCalendar} onHide={toggleCalendar} centered>
        <Modal.Header>
          <div className="form-modal-title-container">
            <Modal.Title className="form-modal-title">Selecciona una Fecha</Modal.Title>
          </div>
          <Button variant="none" className="modal-close-button" onClick={toggleCalendar}>
            <X size={24} />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className="mp-form-calendar-container">
            <Calendar
              onChange={(date) => {
                const selected = date as Date;
                setSelectedDate(selected);
                setFormData({
                  ...formData,
                  dob: selected.toLocaleDateString("en-CA"),
                });
                toggleCalendar();
              }}
              value={selectedDate}
              locale="es-ES"
              className="mp-form-calendar"
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal de Error */}
      <div className="modal-fecha-invitacion-usuario">
        <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
          <Modal.Header>
            <div className="form-modal-title-container">
              <Modal.Title className="form-modal-title">Error en el registro</Modal.Title>
            </div>
            <Button variant="none" className="modal-close-button" onClick={() => setShowErrorModal(false)}>
              <X size={24} />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className="error-icon-container">
              <FontAwesomeIcon icon={faFaceSadTear} className="error-icon" />
            </div>
            <p>No se pudo validar la invitación.</p>
            <p>¡Contacta al administrador del local para reactivar tu invitación!</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="none" className="form-button-cancel" onClick={() => setShowErrorModal(false)}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default UserInvitationPage;
